<template>
  <div>
    <main class="smartphone">
      <div class="Kyuyo_MainArea">
        <b-container fluid>
          <div class="WorkState">
            <div class="WorkStateConditionArea" style="border-top: none; padding-bottom: 0.5rem;">
              <div class="ConditionRow d-flex">
                <div class="ConditionEachArea w-100">
                  <div class="EachRow d-flex flex-wrap align-items-center" style="row-gap: 0.5rem;">
                    <div class="d-flex align-items-center">
                      <label class="labelTitle labelTitleWorkState pt-0" style="min-width:60px;">月度</label>
                      <b-select :options="optionYear" v-model="selectYear" @change="getWorkStateList" style="width: 85px"></b-select>
                      <label class="labelTitle pt-0 pl-2">年</label>
                      <b-select :options="optionMonth" v-model="selectMonth" @change="getWorkStateList" style="width: 70px"></b-select>
                      <label class="labelTitle pt-0 pl-2">月</label>
                    </div>
                    <div class="d-flex align-items-center">
                      <!--集計表画面から遷移した際、選択した社員番号と社員名を表示する-->
                      <label v-if="showUserInfo" class="labelTitle pt-0" style="min-width:60px;">対象者</label>
                      <b-select v-if="showUserInfo" :options="optionShain" v-model="targetUserCd" @change="getWorkStateList" class="selectSectionPart"></b-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 一覧 -->
            <div class="WorkStateListArea small">
              <div>
                <b-table class="WorkStateListTable mb-0" :items="listData" :fields="listFields" small sticky-header @row-clicked="clickDate">
                  <template #cell(show_details)="row">
                    <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails" class="d-none"></b-form-checkbox>
                    <b-button @click="row.toggleDetails" size="" v-show="row.item.detailInfo!=null" class="detailButton pt-0 pb-0 pl-1 pr-1">
                      {{ row.detailsShowing ? '▲' : '▼'}}
                    </b-button>
                  </template>
                  <template #row-details="row">
                    <b-card no-body>
                      <b-row class="mt-0 mb-0 pt-0 pb-0 WorkStateListDetailArea">
                        <b-col class="mt-0 mb-0">
                          <b-table class="WorkStateListDetailTable mb-0" :items="row.item.detailInfo" :fields="detailListFields" small >
                            <template #cell(constractionCode)="row">
                              <div class="constructionNameArea">{{ row.item.constractionCode == 0 ? "" : row.item.constractionCode}}</div>
                            </template>
                            <template #cell(constractionShortName)="row">
                              <div class="constructionNameArea">{{ row.item.constractionShortName == null ? "" : row.item.constractionShortName}}</div>
                            </template>
                          </b-table>
                        </b-col>
                      </b-row>
                    </b-card>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- 一覧 -->
            <div class="WorkSummaryListArea small">
              <div class="mt-3">
                <label class="labelTitle pt-0">集計情報</label>
                  <b-table id="work-summary-table" class="WorkSummaryListTable mb-0" :items="workSummaryList"
                  :fields="workSummaryFields" responsive="sm" small bordered
                  :tbody-tr-class="rowClass">

                <template #head(departmentName)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>部</p>
                  </div>
                  <div>
                    <p>課</p>
                  </div>
                </template>
                <template #head(shainName)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>氏名</p>
                  </div>
                  <div>
                    <p>社員番号</p>
                  </div>
                </template>
                <template #head(isNotBacklog)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128); margin-top: -6px;">
                    <p>未提出</p>
                  </div>
                  <div style="border-bottom: 1px dashed rgb(128,128,128); margin-top: -3px; margin-bottom: -3px;">
                    <p>未確定</p>
                  </div>
                  <div style="margin-bottom: -6px;">
                    <p>未承認</p>
                  </div>
                </template>
                  <template #head(weekdayCount)>
                    <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>義務日数</p>
                  </div>
                  <div>
                    <p>欠勤日数</p>
                  </div>
                </template>
                <template #head(weekdayAttendanceDays)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>平日出勤日数</p>
                  </div>
                  <div>
                    <p>平日就業日数</p>
                  </div>
                </template>
                <template #head(overtimeWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>時間外労働(月)</p>
                  </div>
                  <div>
                    <p>残業MAX</p>
                  </div>
                </template>
                <template #head(yealyOvertimeWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>時間外労働(年)</p>
                  </div>
                  <div>
                    <p>残業MAX</p>
                  </div>
                </template>
                <template #head(weekdayOvertimeWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>残業</p>
                  </div>
                  <div>
                    <p>(内)深夜</p>
                  </div>
                </template>
                <template #head(holidayAllowanceWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>休日</p>
                  </div>
                  <div>
                    <p>(内)深夜</p>
                  </div>
                </template>
                <template #head(legalHolidayAllowanceWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>公休</p>
                  </div>
                  <div>
                    <p>(内)深夜</p>
                  </div>
                </template>
                <template #head(lateLeaveEarlyTime)>
                  <div>
                    <p>他振</p>
                  </div>
                  <div>
                    <p>等</p>
                  </div>
                </template>
                <template #head(paidHolidayDays)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>有休</p>
                  </div>
                  <div>
                    <p>有休残</p>
                  </div>
                </template>
                <template #head(paidHolidayTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>時間有休</p>
                  </div>
                  <div>
                    <p>法定取得</p>
                  </div>
                </template>
                <template #head(holidayTransferWorkTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>休日(振替)</p>
                  </div>
                  <div>
                    <p>公休(振替)</p>
                  </div>
                </template>
                <template #head(substituteHolidayTime)>
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p>振休</p>
                  </div>
                  <div>
                    <p>振休残</p>
                  </div>
                </template>


                <!--部/課-->
                <template #cell(departmentName)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); text-align:left;">
                    <p v-if="!emptyCheck(data.item.departmentName)">{{ data.item.departmentName }}</p>
                  </div>
                  <div style=" text-align:left;">
                    <p v-if="!emptyCheck(data.item.sectionName)">{{ data.item.sectionName }}</p>
                  </div>
                </template>
                <!--氏名/社員番号-->
                <template #cell(shainName)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); text-align:left;">
                    <p v-if="!emptyCheck(data.item.shainName)">{{ data.item.shainName }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.shainCd)">{{ data.item.shainCd }}</p>
                  </div>
                </template>
                <!--未提出/未確定/未承認-->
                <template #cell(isNotBacklog)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); margin-top: -6px;">
                    <p v-if="data.item.isNotBacklog">あり</p>
                  </div>
                  <div style="border-bottom: 1px dashed rgb(128,128,128); margin-top: -3px; margin-bottom: -3px;">
                    <p v-if="data.item.isNotConfirm">あり</p>
                  </div>
                  <div style="margin-bottom: -6px;">
                    <p v-if="data.item.isNotApproval">あり</p>
                  </div>
                </template>
                <!--警告-->
                <template #cell(alertStatus)="data">
                  <div>
                    <p v-if="data.item.alertStatus == 1">警告</p>
                    <p v-else-if="data.item.alertStatus == 2">要指導</p>
                  </div>
                </template>
                <!--義務日数/欠勤日数-->
                <template #cell(weekdayCount)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.weekdayCount)">{{ data.item.weekdayCount }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.absenceDays)">{{ data.item.absenceDays }}</p>
                  </div>
                </template>
                <!--平日出勤日数/平日就業日数-->
                <template #cell(weekdayAttendanceDays)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.weekdayAttendanceDays)">{{ data.item.weekdayAttendanceDays }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.weekdayWorkingDays)">{{ data.item.weekdayWorkingDays }}</p>
                  </div>
                </template>
                <!--時間外労働/残業MAX-->
                <template #cell(overtimeWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.overtimeWorkTime)" class="overtime">{{ data.item.overtimeWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.overtimeWarningTime)">{{ data.item.overtimeWarningTime }}</p>
                  </div>
                </template>
                <!--年間時間外労働/残業MAX-->
                <template #cell(yealyOvertimeWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.yealyOvertimeWorkTime)" class="overtime">{{ data.item.yealyOvertimeWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.yealyOvertimeWarningTime)">{{ data.item.yealyOvertimeWarningTime }}</p>
                  </div>
                </template>
                <!--基準内-->
                <template #cell(weekdayOvertimeWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.weekdayOvertimeWorkTime)">{{ data.item.weekdayOvertimeWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.weekdayLateNightWorkTime)">{{ data.item.weekdayLateNightWorkTime }}</p>
                  </div>
                </template>
                <!--休日-->
                <template #cell(holidayAllowanceWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.holidayAllowanceWorkTime)">{{ data.item.holidayAllowanceWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.holidayAllowanceLateNightWorkTime)">{{ data.item.holidayAllowanceLateNightWorkTime }}</p>
                  </div>
                </template>
                <!--公休-->
                <template #cell(legalHolidayAllowanceWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.legalHolidayAllowanceWorkTime)">{{ data.item.legalHolidayAllowanceWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.legalHolidayAllowanceLateNightWorkTime)">{{ data.item.legalHolidayAllowanceLateNightWorkTime }}</p>
                  </div>
                </template>
                <!--有休/有休残-->
                <template #cell(paidHolidayDays)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); display:flex; justify-content: center;">
                    <p class="pr-1" v-if="(data.item.paidHolidayDays) != null">{{ data.item.paidHolidayDays.toFixed(1) }}日</p>
                    <p v-if="(data.item.paidHolidayYearlyCount) != null">{{ "(" + data.item.paidHolidayYearlyCount.toFixed(1) + "日)" }}</p>
                  </div>
                  <div>
                    <p v-if="(data.item.remainPaidHolidayDays) != null">{{ data.item.remainPaidHolidayDays.toFixed(1) }}日</p>
                  </div>
                </template>
                <!--時間有休/法定取得-->
                <template #cell(paidHolidayTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); display:flex; justify-content: center;">
                    <p class="pr-1" v-if="(data.item.paidHolidayTime) != null">{{ data.item.paidHolidayTime }}</p>
                    <p v-if="(data.item.maxPaidHolidayTime) != null">{{ "(" + data.item.maxPaidHolidayTime + ")" }}</p>
                  </div>
                  <div style="display:flex; justify-content: center;">
                    <p class="pr-1" v-if="(data.item.paidHolidayOverHalfCount) != null">{{ data.item.paidHolidayOverHalfCount }}回</p>
                    <p v-if="(data.item.maxPaidHolidayOverHalfCount) != null">{{ "(" + data.item.maxPaidHolidayOverHalfCount + "回)" }}</p>
                  </div>
                </template>
                <!--特休-->
                <template #cell(specialHolidayTime)="data">
                  <div style="display:flex; justify-content: center;">
                    <p class="pr-1" v-if="!emptyCheck(data.item.specialHolidayTime)">{{ data.item.specialHolidayTime }}</p>
                    <p v-if="!emptyCheck(data.item.specialHolidayDays)">{{ "(" + data.item.specialHolidayDays + "日)" }}</p>
                  </div>
                </template>
                <!--休日(振替)/公休(振替)-->
                <template #cell(holidayTransferWorkTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128)">
                    <p v-if="!emptyCheck(data.item.holidayTransferWorkTime)">{{ data.item.holidayTransferWorkTime }}</p>
                  </div>
                  <div>
                    <p v-if="!emptyCheck(data.item.legalHolidayTransferWorkTime)">{{ data.item.legalHolidayTransferWorkTime }}</p>
                  </div>
                </template>
                <!--振休/振休残-->
                <template #cell(substituteHolidayTime)="data">
                  <div style="border-bottom: 1px dashed rgb(128,128,128); display: flex; justify-content: center;">
                    <p class="pr-1" v-if="!emptyCheck(data.item.substituteHolidayTime)">{{ data.item.substituteHolidayTime }}</p>
                    <p v-if="!emptyCheck(data.item.substituteHolidayDays)">{{ "(" + data.item.substituteHolidayDays + "日)" }}</p>
                  </div>
                  <div style="display: flex; justify-content: center;">
                    <p class="pr-1" v-if="!emptyCheck(data.item.remainSubstituteHolidayTime)">{{ data.item.remainSubstituteHolidayTime }}</p>
                    <p v-if="!emptyCheck(data.item.remainSubstituteHolidayDays)">{{ "(" + data.item.remainSubstituteHolidayDays + "日)" }}</p>
                  </div>
                </template>

                </b-table>

              </div>
            </div>
            <div class="WorkSummaryListArea small">
              <div class="mt-3">
                <label class="labelTitle pt-0">勤務・休暇情報</label>
                <div style="overflow-x: auto">
                  <b-table class="WorkStateMonthlyTable mb-0" :items="monthlyData" :fields="monthlyFields" small bordered></b-table>
                </div>
              </div>
            </div>
            <div class="WorkSummaryListArea small">
              <div class="mt-3 mb-3">
                <label class="labelTitle pt-0">工事別内訳</label>
                <div style="overflow-x: auto;">
                  <b-table 
                    class="WorkStateConstructionTable mb-0" 
                    :items="constructionInfoList" 
                    :fields="constructionInfoListFields" 
                    small 
                    sticky-header 
                    bordered
                    style=""
                  >
                    <template #cell(constractionCode)="row">
                      <div class="constructionNameArea">{{ row.item.constractionCode == 0 ? "" : row.item.constractionCode}}</div>
                    </template>
                    <template #cell(constractionName)="row">
                      <div class="constructionNameArea">{{ row.item.constractionName == null ? "" : row.item.constractionName}}</div>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </div>
    </main>
  </div>
</template>

<script>
import config from "../const/config";
export default {
  name: "WorkState",
  components: {},
  data() {
    return {
      systemVersion: null,
      workerSelected: "0012346",
      monthlyData: [],
      monthlyFields: [
        {
          key: 'workingDays',
          class: "col_workday",
          thClass: 'table-header',
          label: "出勤日数",
          sortable: false,
        },
        {
          key: 'workingHolidayDays',
          class: "col_workholiday",
          thClass: 'table-header',
          label: "休出日数",
          sortable: false,
        },
        {
          key: 'paidHolidayDays',
          class: "col_paidday",
          thClass: 'table-header',
          label: "有休消化日数",
          sortable: false,
        },
        {
          key: 'paidHolidayTime',
          class: "col_paidtime",
          thClass: 'table-header',
          label: "有休消化時間",
          sortable: false,
        },
      ],
      listFields: [
        {
          key: 'show_details',
          class: "col_show_details",
          thClass: 'table-header',
          label: "",
          sortable: false,
        },
        {
          key: 'day',
          class: "col_day",
          thClass: 'table-header',
          label: "日付",
          sortable: false,
        },
        {
          key: 'confirmedFlg',
          class: "col_confirm",
          thClass: 'table-header',
          label: "未確定",
          sortable: false
        },
        {
          key: 'approvalFlg',
          class: "col_confirm",
          thClass: 'table-header',
          label: "未承認",
          sortable: false
        },
        {
          key: 'shift',
          class: "col_shift",
          thClass: 'table-header',
          label: "シフト",
          sortable: false
        },
        {
          key: 'workStart',
          class: "col_time",
          thClass: 'table-header',
          label: "開始",
          sortable: false
        },
        {
          key: 'workFinish',
          class: "col_time",
          thClass: 'table-header',
          label: "終了",
          sortable: false
        },
        {
          key: 'workingTime',
          class: "col_worktime",
          thClass: 'table-header',
          label: "勤務時間",
          sortable: false
        },
        {
          key: 'overtimeTime',
          class: "col_overtime",
          thClass: 'table-header',
          label: "残業",
          sortable: false
        },
        {
          key: 'lateNightTime',
          class: "col_state_time",
          thClass: 'table-header',
          label: "深夜",
          sortable: false
        },
        {
          key: 'holidayWorkingFlg',
          class: "col_state_time",
          thClass: 'table-header',
          label: "休日",
          sortable: false
        },
        {
          key: 'paidVacationFlg',
          class: "col_state_time",
          thClass: 'table-header',
          label: "有給休暇",
          sortable: false
        },
        {
          key: 'specialVationFlg',
          class: "col_state_time",
          thClass: 'table-header',
          label: "特休",
          sortable: false
        },
        {
          key: 'absenceFlg',
          class: "col_state_time",
          thClass: 'table-header',
          label: "欠勤",
          sortable: false
        },
        {
          key: 'stepOutFlg',
          class: "col_state_time",
          thClass: 'table-header',
          label: "その他振替",
          sortable: false
        },
        {
          key: 'substitureHolidayFlg',
          class: "col_state_time",
          thClass: 'table-header',
          label: "振休",
          sortable: false,
        },
        {
          key: 'lateArrivalEarlyDepatureFlg',
          class: "col_state_time",
          thClass: 'table-header',
          label: "★その他",
          sortable: false,
        },
        {
          key: 'note',
          class: "col_note",
          thClass: 'table-header',
          label: "備考",
          sortable: false
        },
      ],
      detailListFields: [
        {
          key: 'constractionCode',
          class: "col_constraction_code",
          label: "",
          sortable: false
        },
        {
          key: 'constractionShortName',
          class: "col_constraction_name",
          label: "",
          sortable: false
        },
        {
          key: 'workStart',
          class: "col_time",
          label: "開始",
          sortable: false
        },
        {
          key: 'workFinish',
          class: "col_time",
          label: "終了",
          sortable: false
        },
        {
          key: 'workingTime',
          class: "col_worktime",
          label: "勤務時間",
          sortable: false
        },
        {
          key: 'overtimeTime',
          class: "col_overtime",
          label: "残業",
          sortable: false
        },
        {
          key: 'lateNightTime',
          class: "col_state_time",
          label: "深夜",
          sortable: false
        },
        {
          key: 'holidayWorkingTime',
          class: "col_state_time",
          label: "休日",
          sortable: false
        },
        {
          key: 'paidVacationTime',
          class: "col_state_time",
          label: "有給休暇",
          sortable: false
        },
        {
          key: 'specialVacationTime',
          class: "col_state_time",
          thClass: 'table-header',
          label: "特休",
          sortable: false
        },
        {
          key: 'absenceTime',
          class: "col_state_time",
          thClass: 'table-header',
          label: "欠勤",
          sortable: false
        },
        {
          key: 'stepOutTime',
          class: "col_state_time",
          thClass: 'table-header',
          label: "その他振替",
          sortable: false
        },
        {
          key: 'substituteHolidayTime',
          class: "col_state_time",
          label: "振休",
          sortable: false
        },
        {
          key: 'lateArrivalEarlyDepartureTime',
          class: "col_state_time",
          label: "★その他",
          sortable: false
        },
        {
          key: 'note',
          class: "col_note",
          label: "備考",
          sortable: false
        },
      ],
      constructionInfoListFields:[
        {
          key: 'constractionCode',
          class: "col_constraction_code",
          thClass: 'table-header',
          label: "工事CD",
          sortable: false,
        },
        {
          key: 'constractionName',
          class: "col_constraction_name",
          thClass: 'table-header',
          label: "工事名",
          sortable: false,
        },
        {
          key: 'workTime',
          class: "col_work_time",
          thClass: 'table-header',
          label: "勤務時間",
          sortable: false,
        },
      ],
      listData: [],
      conditionRequestShainCode: null,
      loginUserId: null,
      loginUserName: null,
      userPart: null,
      userSection: null,
      optionYear: [],
      optionMonth: [
        { value: 1, text: "01" },
        { value: 2, text: "02" },
        { value: 3, text: "03" },
        { value: 4, text: "04" },
        { value: 5, text: "05" },
        { value: 6, text: "06" },
        { value: 7, text: "07" },
        { value: 8, text: "08" },
        { value: 9, text: "09" },
        { value: 10, text: "10" },
        { value: 11, text: "11" },
        { value: 12, text: "12" },
      ],
      selectYear: 0,
      selectMonth: 0,
      systemAuthorityType: 0,
      targetUserCd: null,
      targetUserName: null,
      showUserInfo: false,
      optionShain:[],
      constructionInfoList:[],
      
      // 集計表情報 表示用
      workSummaryFields: [
        {
          key: 'officeName',
          class: 'col_officeName',
          thClass: 'table-header',
          label: '本店/支店',
          sortable: false,
        },
        {
          key: 'departmentName',
          class: 'col_departmentName',
          thClass: 'table-header',
          label: '部',
          sortable: false,
        },
        {
          key: 'shainName',
          class: 'col_shainName',
          thClass: 'table-header',
          label: '氏名(社員番号)',
          sortable: false,
        },
        {
          key: 'isNotBacklog',
          class: 'col_isNotBacklog',
          thClass: 'table-header',
          label: '未提出',
          sortable: false,
        },
        {
          key: 'alertStatus',
          class: 'col_alertStatus',
          thClass: 'table-header',
          label: '警告',
          sortable: false,
        },
        {
          key: 'weekdayCount',
          class: 'col_weekdayCount',
          thClass: 'table-header',
          label: '義務日数',
          sortable: false,
        },
        {
          key: 'weekdayAttendanceDays',
          class: 'col_weekdayAttendanceDays',
          thClass: 'table-header',
          label: '平日就業日数',
          sortable: false,
        },
        {
          key: 'overtimeWorkTime',
          class: 'col_ovetrtime_work_total_time',
          thClass: 'table-header',
          label: '時間外労働',
          sortable: false,
        },
        {
          key: 'yealyOvertimeWorkTime',
          class: 'col_yealy_ovetrtime_work_total_time',
          thClass: 'table-header',
          label: '時間外労働',
          sortable: false,
        },
        {
          key: 'weekdayRegularWorkTime',
          class: 'col_weekdayRegularWorkTime',
          thClass: 'table-header',
          label: '基準内',
          sortable: false,
        },
        {
          key: 'weekdayOvertimeWorkTime',
          class: 'col_weekdayOvertimeWorkTime',
          thClass: 'table-header',
          label: '残業',
          sortable: false,
        },
        {
          key: 'holidayAllowanceWorkTime',
          class: 'col_holidayAllowanceWorkTime',
          thClass: 'table-header',
          label: '休日',
          sortable: false,
        },
        {
          key: 'legalHolidayAllowanceWorkTime',
          class: 'col_legalHolidayAllowanceWorkTime',
          thClass: 'table-header',
          label: '公休',
          sortable: false,
        },
        {
          key: 'overtimeDisasterWorkTime',
          class: 'col_overtimeDisasterWorkTime',
          thClass: 'table-header',
          label: '災害対象',
          sortable: false,
        },
        {
          key: 'lateLeaveEarlyTime',
          class: 'col_lateLeaveEarlyTime',
          thClass: 'table-header',
          label: '他振等',
          sortable: false,
        },
        {
          key: 'paidHolidayDays',
          class: 'col_paidHolidayTime',
          thClass: 'table-header',
          label: '有休',
          sortable: false,
        },
        {
          key: 'paidHolidayTime',
          class: 'col_paidHolidayTime',
          thClass: 'table-header',
          label: '時間有休',
          sortable: false,
        },
        {
          key: 'specialHolidayTime',
          class: 'col_specialHolidayTime',
          thClass: 'table-header',
          label: '特休',
          sortable: false,
        },
        {
          key: 'holidayTransferWorkTime',
          class: 'col_holidayTransferWorkTime',
          thClass: 'table-header',
          label: '休日(振替)',
          sortable: false,
        },
        {
          key: 'substituteHolidayTime',
          class: 'col_substituteHolidayTime',
          thClass: 'table-header',
          label: '振休',
          sortable: false,
        },
      ],
      workSummaryList: [],
    };
  },
  computed: {},
  watch: {},
  mounted: function () {
    this.systemVersion = this.$store.getters.getSystemVersion;
    this.loginUserId = this.$store.state.user_id;
    this.loginUserName = this.$store.state.user_name;
    this.systemAuthorityType = this.$store.state.system_authority_type;
    this.conditionRequestShainCode = this.$store.state.user_id;
    this.selectYear = 0;
    this.selectMonth = 0;

    // 集計表画面から遷移してきたか確認
    if(this.$store.state.is_from_work_summary){
      this.targetUserCd = this.$store.state.target_user_cd;
      this.targetUserName = this.$store.state.target_user_name;
      this.selectYear = this.$store.state.target_year;
      this.selectMonth = this.$store.state.target_month;
      let isFromWorkSummary = {
        is_from_work_summary: false,
      };
      this.$store.commit("setIsFromWorkSummary", isFromWorkSummary);
    }
    else{
      this.targetUserCd = this.loginUserId;
      this.targetUserName = this.loginUserName;
    }
    console.log("targetUserCd：" + this.targetUserCd);
    console.log("targetUserName：" + this.targetUserName);

    this.getWorkStateList();
    console.log("systemAuthorityType：" + this.systemAuthorityType);
    if(this.systemAuthorityType == 1 || this.systemAuthorityType == 2){
      this.showUserInfo = true;
      this.getShainList();
    }
    else{
      this.showUserInfo = false;
    }
    this.userPart = "工事部";
    this.userSection = "管理課";
  },
  methods: {
    getDispSegment: function (segmentCd) {
      let optionSegment = config.OPTIONS.WORK_SEGMENT_SIMPLE;
      let result = "";
      optionSegment.forEach((element) => {
        if (element.value == segmentCd) {
          result = element.text;
        }
      });
      return result;
    },
    getWorkStateList: function(){
      this.getWorkStateListFromAPI();
    },
    // APIから勤務状況リストを取得
    getWorkStateListFromAPI: function(){
      let targetMonth = null;
      if(this.selectYear > 0 && this.selectMonth > 0){
        targetMonth = this.selectYear + "-" + String(this.selectMonth).padStart(2, '0');
      }
      let paramList = {
        shainCd: this.targetUserCd,
        targetMonth: targetMonth
      };
      this.getWithParams(config.URL.WORK_STATUS, paramList)
        .then((response) => {
          // レスポンスの結果がfalseならエラーメッセージを表示
          if(!response.result){
            this.showAlertError(config.MESSAGE.SERVER_ERROR);
            return;
          }
          console.debug("response：" + JSON.stringify(response));
          this.setWorkStateList(response.container);
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.log(e);
        })
        .finally(() => {});
    },
    setWorkStateList: function(items){
      this.listData = items.dailyInfoList;
      this.monthlyData = [];
      this.monthlyData.push(items.monthSummaryInfo);

      // 年月情報を入力欄にセットする
      const [targetYear, targetMonth] = items.targetMonth.split('-');
      this.currentDate = items.currentDate;

      let standardYear = parseInt(this.currentDate.substring(0, this.currentDate.indexOf("/")));

      let optionYear = 
        [
          {
            value: standardYear + 1,
            text: String(standardYear + 1)
          },
          {
            value: standardYear,
            text: String(standardYear)
          },
          {
            value: standardYear - 1,
            text: String(standardYear - 1)
          },
          {
            value: standardYear - 2,
            text: String(standardYear - 2)
          }
        ];
      this.optionYear = optionYear;

      this.selectYear = parseInt(targetYear);
      this.selectMonth = parseInt(targetMonth);

      this.constructionInfoList = items.constructionInfoList;

      // 集計表情報
      this.workSummaryList = items.eachStaffList;
    },
    getShainList: function(){
      let paramList = {
        shainCd: this.loginUserId
      }
      this.getWithParams(config.URL.USER_INFO_MEMBER_LIST, paramList)
        .then((response) => {
          // レスポンスの結果がfalseならエラーメッセージを表示
          if(!response.result){
            this.showAlertError(config.MESSAGE.SERVER_ERROR);
            return;
          }
          console.debug("response：" + JSON.stringify(response));
          this.setShainList(response.container);
        })
        .catch((e) => {
          // Note: エラーメッセージは、共通処理で表示している
          console.log(e);
        })
        .finally(() => {});
    },
    setShainList: function(items){
      let shainList = items.staffList;
      shainList.forEach((shainInfo) => {
        let shainOption = {
          value:shainInfo.shainCd,
          text:shainInfo.shainName
        };
        console.debug("shainOption：" + JSON.stringify(shainOption));
        console.debug("shainOption：" + typeof(shainOption));
        this.optionShain.push(shainOption);
      })
    },
    // 日付をクリックした際の動作
    clickDate(dateData){
      if(this.targetUserCd != this.loginUserId){
        return;
      }
      if(dateData.date == null){
        return;
      }
      const routerWorkRegist = config.PAGES.WORK_REGIST; // 定数：勤怠報告画面遷移
      const routerApplicationRegist = config.PAGES.APPLICATION_REGIST; // 定数：事前申請画面遷移
      console.debug("dateData：" + JSON.stringify(dateData));
      let selectDate = new Date(dateData.date);
      let currentDate = new Date(this.currentDate);
      if(selectDate <= currentDate){
        let targetDateInfo = {
          target_date: selectDate.getFullYear() * 10000 + (selectDate.getMonth() + 1) * 100 + selectDate.getDate(),
          is_from_work_calendar: true,
        };
        this.$store.commit("setTargetDateInfo", targetDateInfo);
        this.$router.push(routerWorkRegist);
      }
      else{
        let targetDateInfo = {
          target_date: dateData.date,
          is_from_work_calendar: true,
        };
        this.$store.commit("setTargetDateInfo", targetDateInfo);
        this.$router.push(routerApplicationRegist);
      }
    },
    rowClass(item, type) {
        let styleClass = "";
        if (!item || type !== 'row') return
        
        // 警告欄
        if (item.alertStatus == 1) {
          styleClass += " alert-row-1";
        } else if (item.alertStatus == 2) {
          styleClass += " alert-row-2";
        }

        // 時間外労働(月)
        if (item.monthAlertStatus == 1) {
          styleClass += " month-alert-row-1";
        } else if (item.monthAlertStatus == 2) {
          styleClass += " month-alert-row-2";
        }

        // 時間外労働(年)
        if (item.yealyAlertStatus == 1) {
          styleClass += " yealy-alert-row-1";
        } else if (item.yealyAlertStatus == 2) {
          styleClass += " yealy-alert-row-2";
        }

        return styleClass;
    },
    // 空文字かチェック
    // true: 空文字
    // false: 空文字ではない
    emptyCheck(text){
      if(text != null && text != ""){
        return false;
      }
      else{
        return true;
      }
    }
  },
};
</script>
<style>
.WorkState {
  padding: 0 1rem;
}
.WorkStateConditionArea {
  padding: 1rem;
  margin-bottom: 1rem;
  border-bottom: 1px solid rgb(82, 75, 75);
}
.sectionName {
  width: 100px;
}

.WorkerList {
  width: 200px;
  min-width: 200px;
}

.WorkStateListArea {
  max-height: 550px;
  border-bottom: 1px solid rgb(212, 212, 212);
}

.WorkStateListTable {
  min-height: 280px;
  max-height: calc(35svh) !important;
  overflow-x: auto;
}
.table-header, .WorkStateListTable th.table-header, .WorkStateConstructionTable th.table-header {
  font-weight: bold;
  background-color: rgb(204, 211, 255) !important;
  text-align: center !important;
}

.WorkStateListTable th, .WorkStateListTable td {
  text-align: center;
}
/* 最終行(合計行) */
.WorkStateListTable > table > tbody > tr:last-child {
  background-color: #ffeedd;
}
.WorkStateListDetailTable th {
  display: none;
}
.WorkStateListDetailTable td {
  color: rgb(158, 104, 39);
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.constructionNameArea {
  padding-right: 0.25em;
  padding-left: 0.25em;
}

.col_show_details {
	width: 30px;
}
.detailButton {
  transform: rotate(270deg);
  font-size: smaller !important;
}
.col_day {
	min-width: 75px;
}
.col_shift {
	min-width: 110px;
}
.col_confirm {
	min-width: 60px;
}
.col_constraction_code {
	min-width: 60px;
  text-align: right !important;
}
.col_constraction_name {
	/* min-width: 150px; */
  min-width: 270px;
  text-align: left !important;
}
.col_time {
	min-width: 50px;
}
.col_worktime {
	min-width: 110px;
}
.col_overtime {
	min-width: 100px;
}
.col_state {
	min-width: 50px;
}
.col_state_time {
	min-width: 100px;
}
.col_note {
  width:auto;
	min-width: 700px;
  text-align: left !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:0px;
}
.col_margin {
  width: 10px;
}

.WorkStateMonthlyTable {
  min-width: 400px;
  border-bottom: 1px solid rgb(212, 212, 212);
}
.WorkStateMonthlyTable td, .WorkStateMonthlyTable th {
  text-align: center;
}
.labelTitleWorkState{
  min-width: 60px;
}
.WorkStateMonthlyTable .col_paidtime{
	width: 120px;
  text-align:center;
}

.smartphone .WorkStateConstructionTable {
  min-width: 450px;
  max-height: calc(20svh) !important;
  min-height: 70px;
  border-bottom: 1px solid rgb(212, 212, 212);
}
.WorkStateConstructionTable td, .WorkStateConstructionTable th {
  text-align: center;
}
.smartphone .WorkStateConstructionTable .col_constraction_code{
  width:70px;
  text-align:right;
}
.smartphone .WorkStateConstructionTable .col_constraction_name{
  min-width:200px;
  max-width: 500px;
  text-align:left;
}
.smartphone .WorkStateConstructionTable .col_work_time{
	min-width: 60px;
  text-align:center;
}

</style>
